// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"119f0892","442":"aeac4722","710":"5202e045"}[chunkId] + ".chunk.css";
};